export function generateUniqueId() {
  return (Date.now() + Math.random()).toString();
}

export const getCountryFlag = (country: string) => {
  switch (country) {
    case 'US':
      return '🇺🇸';
    case 'CA':
      return '🇨🇦';
    default:
      return '';
  }
};
